import * as React from "react";

import { cn } from "@/shared/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Layout & Size
        "pc:rounded-[10px] flex field-sizing-content min-h-60 w-full rounded-[8px]",
        // Appearance
        "border bg-transparent",
        // Spacing
        "p-4",
        // Typography
        "body-md-regular text-gray-900",
        // Border & Background
        "border-gray-200",
        // Placeholder
        "placeholder:text-gray-400",
        // Focus States
        "focus-visible:border-primary-500 focus-visible:ring-primary-500",
        // Invalid States
        "aria-invalid:ring-red-error aria-invalid:border-red-error",
        // Transitions & Effects
        "transition-[color,box-shadow] outline-none",
        // Disabled States
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Text Wrapping
        "break-all whitespace-pre-line",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
